"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zIndexDeep = exports.zIndexBottom = exports.zIndexDefault = exports.zIndexHigh = exports.zIndexFloating = exports.zIndexToast = exports.zIndexOverlay = exports.zIndexTop = exports.zIndexAuto = void 0;
exports.zIndexAuto = 'auto';
exports.zIndexTop = 9999;
exports.zIndexOverlay = 500;
exports.zIndexToast = 400;
exports.zIndexFloating = 300;
exports.zIndexHigh = 200;
exports.zIndexDefault = 100;
exports.zIndexBottom = 0;
exports.zIndexDeep = -9999;